// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyC9xQDNeFlg-LHmlLkaYKEqh46JH1YDlKw",
  authDomain: "droplly.firebaseapp.com",
  projectId: "droplly",
  storageBucket: "droplly.firebasestorage.app",
  messagingSenderId: "931198107061",
  appId: "1:931198107061:web:e1f2ae1d8b618d89f6adfc",
  measurementId: "G-C45JVKKE4C"
};

// VAPID key for Firebase Cloud Messaging
const VAPID_KEY = "BKJ77IwPFp3bdSvfNcu-T7_l3IYSxWAouTgvp3voZyLDIc7cSXoyUQLxlI2SRlDjJaTLC1mqDHeaIPkZaYiWG4s";

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging(app);

export { messaging, VAPID_KEY };

// Function to get FCM token
export const getFCMToken = async (): Promise<string | null> => {
  try {
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    return token;
  } catch (error) {
    console.error('An error occurred while retrieving token:', error);
    return null;
  }
};

// Function to listen for foreground messages
export const onForegroundMessage = (callback: (payload: any) => void) => {
  return onMessage(messaging, callback);
};
